export class fgStockTransferReq{
    transferType: string;
    Date:any;
    unitId:number;
}

export class fgStockRepackingReportReq{
    transferType?: string;
    fromOutDate?:string
    fromInDate?:string
    toOutDate?:string
    toInDate?:string
}